export const depositDisplayType = {
  SECURITY: 'security',
  HOLDING: 'holding'
};
